<template>
    <section class="opui-section">
        <div class="opui-top-menu opui-d-flex opui-justify-content-between opui-align-items-center opui-mb-0">
            <ul class="opui-pl-5">
                <li class="opui-d-flex opui-align-items-center">
                    <router-link to="/" class="opui-logo">
                        <i class="opui-icon-logo"></i>
                    </router-link>
                </li>
            </ul>

            <nav class="opui-main-menu">
                <input class="opui-hamburger-input" type="checkbox">
                <div class="opui-hamburger-menu">
                    <span class="opui-hamburger-bar"></span>
                    <span class="opui-hamburger-bar"></span>
                    <span class="opui-hamburger-bar"></span>
                </div>

                <ul class="opui-right-menu">
                    <li>
                        <router-link to="/">
                            <i class="opui-icon opui-icon-dashboard-complex"></i>
                            <span>{{ $e('Dashboard') }}</span>
                        </router-link>
                    </li>
                    <li>
                        <router-link to="/logs">
                            <i class="opui-fa opui-fa-database"></i>
                            <span>{{ $e('Logs') }}</span>
                        </router-link>
                    </li>
                    <li>
                        <a href="#" @click.prevent="toggleSubmenu">
                            <i class="opui-icon-logo"></i>
                            <span>{{ $e('Tools')}}</span>
                        </a>

                        <ul class="opui-submenu" :class="{ 'opui-d-block': showSubmenu }">
                            <li v-for="tool in tools">
                                <a :href="tool.url" :title="tool.title"><span>{{ tool.title }}</span></a>
                            </li>
                            <li v-if="window.OptimizeFlow.sl_role === 'superadmin'">
                                <hr>
                                <a href="#" @click.prevent="rebuildDatabase" style="white-space: nowrap">
                                    <span>{{ $e('Rebuild DB') }}</span>
                                </a>
                            </li>
                            <li v-if="window.OptimizeFlow.sl_role === 'superadmin'">
                                <a href="#" @click.prevent="rebuildDatabaseAndSeed" style="white-space: nowrap">
                                    <span>{{ $e('Rebuild DB/Seed') }}</span>
                                </a>
                            </li>
                            <li v-if="window.OptimizeFlow.sl_role === 'superadmin'">
                                <a href="#" @click.prevent="rebuildDatabaseAndMigrate" style="white-space: nowrap">
                                    <span>{{ $e('Rebuild DB/Migrate') }}</span>
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li>
                        <a href="https://optimizelink.com/flow" target="_blank">
                            <i class="opui-icon-help"></i>
                            <span>{{ $e('Help') }}</span>
                        </a>
                    </li>
                    <li class="opui-fullscreen-btn">
                        <a @click.prevent="toggleFullscreenApp" href="#">
                            <i class="opui-icon-fullscreen-fill"></i>
                            <span>{{ $e('Fullscreen') }}</span>
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
    </section>
    <header>
        <div class="opui-submenu opui-d-flex opui-justify-content-between opui-align-items-center opui-pl-5 opui-pr-5">
            <div><slot name="title"></slot></div>

            <div v-if="settingsStore.slLicenseIsValid !== null">
                <div v-if="! settingsStore.slLicenseIsValid">
                    <a class="opui-btn opui-btn-danger" href="https://my.optimizepress.com/account/reactivate" target="_blank">
                        {{ $e('Reactivate license') }}
                    </a>
                </div>
                <div v-else>
                    <slot name="right-menu-buttons"></slot>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import { useSettingsStore } from "../../store/settings"
import { mapStores } from 'pinia'
import { toggleFullscreen } from 'optimizepress-ui/src/js/fullscreen'

export default {
    computed: {
        ...mapStores(useSettingsStore),
    },
    data() {
        return {
            tools: window.OptimizeFlow.tools,
            showSubmenu: false
        }
    },
    created() {
        // console.log(this.settingsStore.opfw);
    },
    methods: {
        /**
         * We are adding class to body and triggering AJAX action from OP Dashboard 'op3toggleFullScreen'
         */
        toggleFullscreenApp() {
            toggleFullscreen()
        },

        /**
         * Toggle the tools submenu
         */
        toggleSubmenu() {
            this.showSubmenu = ! this.showSubmenu
        },

        async rebuildDatabase() {
            if (confirm('Are you sure? You will loose all OptimizeFlow data')) {
                let response = await this.$http.post('flow/rebuild-database')
                let status = await response.status

                if (status === 200) {
                    this.$toast.success('Database rebuilt!.')
                    location.reload()
                } else {
                    console.info('Error when rebuilding database.', response.data)
                }
            }
        },

        async rebuildDatabaseAndSeed() {
            if (confirm('Are you sure? You will loose all OptimizeFlow data and DB will be populated with dummy data.')) {
                let response = await this.$http.post('flow/rebuild-database-seed')
                let status = await response.status

                if (status === 200) {
                    this.$toast.success('Database rebuilt and seeded!.')
                    location.reload()
                } else {
                    console.info('Error when rebuilding database.', response.data)
                }
            }
        },

        async rebuildDatabaseAndMigrate() {
            if (confirm('Are you sure? You will loose all OptimizeFlow and rules will be imported from the Rules Engine.')) {
                let response = await this.$http.post('flow/rebuild-database-migrate')
                let status = await response.status

                if (status === 200) {
                    this.$toast.success('Database rebuilt and migrated!.')
                    location.reload()
                } else {
                    console.info('Error when rebuilding database.', response.data)
                }
            }
        }
    },
}
</script>
